import { isEmpty } from "lodash";
import axiosInstance from "./base";
import { AxiosResponse } from "axios";
import { TEquimetre } from "../shared/types/training.type";
import { CreateEqmSubscriptionDto } from "../dto/CreateEqmSubscriptionDto";
import { CreateReportDto } from "../dto/CreateReportDto";

export class Equimetres {
    static getEquimetres(userId?: string, options?: string[]): Promise<AxiosResponse<TEquimetre[]>> {
        return axiosInstance.get(`equimetres?trainer=${userId}`.concat(!isEmpty(options) ? `&${options?.join('&')}` : ''))
    }

    static updateEqm(id: number, data: Partial<TEquimetre>) {
        return axiosInstance.patch(`equimetres/${id}`, data, {
            headers: {
                'Content-Type': 'application/merge-patch+json',
            }
        })
    }

    static createSubscription(id: number, customer_id: string, payment_method_id: string) {
        return axiosInstance.post(`/mac_addresses/${id}/create-4g-subscription`, { customer_id, payment_method_id })
    }

    static resumeSubscription(id: number) {
        return axiosInstance.post(`/mac_addresses/${id}/resume-4g-subscription`)
    }

    static abortSubscription(id: number) {
        return axiosInstance.post(`/mac_addresses/${id}/cancel-4g-subscription`)
    }

    static createDeviceReport(id: number,data:CreateReportDto) {
        return axiosInstance.post(`arioneo_devices/${id}/report_issue`,data)
    }
}